import { Icon } from "../../../../components/BaseComponents/Icon";

export const SetupIcon = (props) => (
	<Icon fill="none" viewBox="0 0 16 16" {...props}>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.36 2.75a1.43 1.43 0 1 0 0 2.86 1.43 1.43 0 0 0 0-2.86Zm-2.83.68a2.93 2.93 0 1 1 0 1.5H2a.75.75 0 0 1 0-1.5h1.53Zm6.45.75c0-.41.33-.75.75-.75H14a.75.75 0 0 1 0 1.5h-3.27a.75.75 0 0 1-.75-.75Zm-.34 6.2a1.43 1.43 0 1 0 0 2.87 1.43 1.43 0 0 0 0-2.86ZM6.7 11.83a2.93 2.93 0 0 1 5.76-.75H14a.75.75 0 0 1 0 1.5h-1.53a2.93 2.93 0 0 1-5.76-.75Zm-5.46 0c0-.42.34-.75.75-.75h3.27a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75Z"
		/>
	</Icon>
);
